import MaintainTransLog_Sales from './MaintainTransLog_Sales.vue';

export default MaintainTransLog_Sales;


// WEBPACK FOOTER //
// ./src/components/MaintainTransLog_Sales/index.js